import { useEffect } from 'react';
import Api, { baseUrl } from './Api';

const loadClientFont = (fontName, url) => {
  let clientFont = document.createElement('style');
  clientFont.appendChild(
    document.createTextNode('@font-face { font-family: "' + fontName + '"; src: url("' + url + '"); }, ')
  );
  document.head.appendChild(clientFont);
};

export const ClientFontName = 'ClientFont';

export const useClientFont = () => {
  useEffect(() => {
    Api.request('frontendapi/client').then(result => {
      const fontPath = result.data?.theme?.font;
      if (fontPath) {
        const fontUrl = `${baseUrl}/${fontPath}`;
        loadClientFont(ClientFontName, fontUrl);
      }
    })
  }, []);
}

export const withClientFont = (defaultFont) => [ClientFontName, defaultFont].join(', ');
